module.exports = __webpack_public_path__ + "static/pocket-desktop-6004d42cfdd7abe9531240097f3acb8f.png";